import { render, staticRenderFns } from "./MobileJoinButton.vue?vue&type=template&id=b9e51ed0&scoped=true&lang=pug&"
import script from "./MobileJoinButton.vue?vue&type=script&lang=js&"
export * from "./MobileJoinButton.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b9e51ed0",
  null
  
)

export default component.exports